<template>
  <div>
    <span class="badge badge-success">Tasks Page coming soon...</span>
  </div>
</template>

<script>
export default {
  name: "TasksPage"
}
</script>

<style scoped>

</style>